import { SessionContext } from "src/components/session/session";
import { useSignMessage } from "./useSignMessage";
import { useContext, useState } from "react";
import { web3Login } from "./web3Login";
import { CSRFContext } from "src/components/csrf/csrf";

interface UseSignInWithEthResponse {
  login: () => void;
  error: Error | null;
  loading: boolean;
}

export function useLoginInWithEth(): UseSignInWithEthResponse {
  const { refresh: refreshSession } = useContext(SessionContext);
  const [loginLoading, setLoginLoading] = useState<boolean>(false);
  const { csrf } = useContext(CSRFContext);

  const { signMessage, error, loading } = useSignMessage(
    async (signature, address) => {
      setLoginLoading(true);
      return web3Login(address, signature, csrf)
        .then(() => {
          refreshSession();
        })
        .finally(() => {
          setLoginLoading(false);
        });
    }
  );
  return {
    login: signMessage,
    error,
    loading: loading || loginLoading,
  };
}
